import React, { useState } from "react";
import { Tabs } from "../../_styleguide";
import { IconReport } from "@tabler/icons-react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { Header, Text } from "@centrate-io/barn";
import "./CommentReview.scss";
import CommentsTable from "./_components/CommentsTable/CommentsTable";

function CommentReview(props) {
    const navigate = useNavigate();
    const params = useParams();
    const [tab, setTab] = useState(params?.tab) || "sample-tab";
    const deal_id = params.id;
  
    let items = [
      {
        key: "comments-table",
        label: (
          <div className="tab-name">
            <IconReport />
            Comments Table
          </div>
        ),
        children: <CommentsTable deal_id={deal_id}/>,
      },
      {
        key: "sample-tab",
        label: (
          <div className="tab-name">
            <IconReport />
            Sample Tab
          </div>
        ),
        children: <></>,
      },
      {
        key: "sample-tab-2",
        label: (
          <div className="tab-name">
            <IconReport />
            Sample Tab 2
          </div>
        ),
        children: <></>,
      }
    ];
  
    return (
      <div className="admin-tabs app-secured-workflow">
        <div className="admin-header">
          <div className="crumbs" >
            <Header type="display" size="5">
              Comments Review
            </Header>
          </div>
        </div>
        <Tabs
          onChange={(key) => {
            navigate(`/deal/${deal_id}/comment-review/${key}`);
            setTab(key);
          }}
          activeKey={tab}
          items={items}
          className={tab}
          destroyInactiveTabPane={true}
        />
      </div>
    );
  }
  
  export default CommentReview;